import React, { JSX } from "react";
import { BrowserRouter, Route, Routes, Navigate, useLocation, useParams } from "react-router-dom";
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
//import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

// Import your page components
import Home from '../pages/Home';
import Mission from '../pages/Mission';
import Layout from '../components/Layout';
import MultiStepForm from "../pages/MultiStepForm";
import Signup from "../pages/SignUp";
import Blog from "../pages/Blog";
import BlogDetail from "../pages/BlogDetail";
import Help from "../pages/Help";
import Faq from "../pages/Faq";
import Contact from "../pages/Contact";
import Features from "../pages/Features";
import Term from "../pages/Term";
import Privacy from "../pages/Privacy";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Dashboard from "../pages/Dashboard";
import ProfileDetails from "../pages/ProfileDetails";
import DashboardLayout from "../components/Dashboard/DashboardLayout";
import LikedListPage from "../pages/LikedListPage";
import LikedProfileDetails from "../pages/LikedProfileDetails";
import MatchesListPage from "../pages/MatchedListPage";
import MessageBox from "../pages/MessageBox";
import SearchProfile from "../pages/SearchProfile";
import UserProfile from "../pages/UserProfile";
import GenresEdit from "../pages/GenresEdit";
import Settings from "../pages/Settings";
import Zodiac from "../pages/Zodiac";
import Florida from "../pages/Florida";
import Orlando from "../pages/Orlando";
import NewYork from "../pages/NewYork";
import SlammmmLoveStories from "../pages/SlammmmLoveStories";
import Canonical from "../components/Canonical";

const BlogDetailsRedirect: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/blog/${slug}`} replace />;
};

const Routesx: React.FC = () => {

  const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    return useIsAuthenticated() ? children : <Navigate to="/" replace />;
  };

  const PublicRoute = ({ children }: { children: JSX.Element }) => {
    const isAuth = useIsAuthenticated();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const redirectPath = queryParams.get('redirect') || '/dashboard';

    return isAuth ? <Navigate to={redirectPath} replace /> : children;
  };

  return (
    <BrowserRouter>
      <Canonical />
      <Routes>

        {/* ✅ Home route updated */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Layout><Home /></Layout>
            </PublicRoute>
          }
        />

        <Route path="/mission" element={<Layout><Mission /></Layout>} />
        <Route path="/features" element={<Layout><Features /></Layout>} />
        <Route path="/help" element={<Layout><Help /></Layout>} />
        <Route path="/faq" element={<Layout><Faq /></Layout>} />
        <Route path="/contact-dating-agency" element={<Layout><Contact /></Layout>} />
        <Route path="/contact" element={<Navigate to="/contact-dating-agency" replace />} />
        <Route path="/blogs" element={<Layout><Blog /></Layout>} />
        <Route path="/florida" element={<Layout><Florida /></Layout>} />
        <Route path="/orlando" element={<Layout><Orlando /></Layout>} />
        <Route path="/new-york" element={<Layout><NewYork /></Layout>} />
        <Route path="/slammmm-love-stories" element={<Layout><SlammmmLoveStories /></Layout>} />
        <Route path="/terms"element={<Layout><Term /></Layout>} />
        <Route path="/privacy-policy" element={<Layout><Privacy /></Layout>} />
        <Route path="/blog/:slug" element={<Layout><BlogDetail /></Layout>} />
        <Route path="/blog-details/:slug" element={<BlogDetailsRedirect />} />

        {/* Public Routes - Redirect if logged in */}
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/signup" element={<PublicRoute><Signup /></PublicRoute>} />
        <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
        <Route path="/resetpassword/:token" element={<PublicRoute><ResetPassword /></PublicRoute>} />

        <Route path="/onboarding" element={<MultiStepForm />} />

        {/* Private Routes */}
        <Route path="/dashboard" element={<PrivateRoute><DashboardLayout><Dashboard/></DashboardLayout></PrivateRoute>} />
        <Route path="/profile/:userId" element={<PrivateRoute><DashboardLayout><ProfileDetails /></DashboardLayout></PrivateRoute>} />
        <Route path="/liked" element={<PrivateRoute><DashboardLayout><LikedListPage /></DashboardLayout></PrivateRoute>} />
        <Route path="/liked-profile/:userId/:requestId" element={<PrivateRoute><DashboardLayout><LikedProfileDetails /></DashboardLayout></PrivateRoute>} />
        <Route path="/matched" element={<PrivateRoute><DashboardLayout><MatchesListPage /></DashboardLayout></PrivateRoute>} />
        <Route path="/messages/:requestId" element={<PrivateRoute><DashboardLayout><MessageBox /></DashboardLayout></PrivateRoute>} />
        <Route path="/search" element={<PrivateRoute><DashboardLayout><SearchProfile /></DashboardLayout></PrivateRoute>} />
        <Route path="/myprofile" element={<PrivateRoute><DashboardLayout><UserProfile /></DashboardLayout></PrivateRoute>} />
        <Route path="/genres-edit" element={<PrivateRoute><DashboardLayout><GenresEdit /></DashboardLayout></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><DashboardLayout><Settings /></DashboardLayout></PrivateRoute>} />
        <Route path="/zodiac" element={<PrivateRoute><DashboardLayout><Zodiac /></DashboardLayout></PrivateRoute>} />

      </Routes>
    </BrowserRouter>
  );
};

export default Routesx;